import { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import ReusableModal from "./Model";
import { MdOutlineAttachFile } from "react-icons/md";

const ChatModal = ({ open, onClose, ticket, chatMessages, setChatMessages }) => {
    const [chatInput, setChatInput] = useState("");
    const [attachedFile, setAttachedFile] = useState(null);


    // Helper to format time as "hh:mm AM/PM"
    const formatTime = () => {
        const now = new Date();
        return now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    };

    const handleSend = () => {
        if ((chatInput.trim() === "" && !attachedFile) || !ticket) return;

        const newMessage = {
            sender: "user",
            text: chatInput || "",
            time: formatTime(),
            file: attachedFile ? attachedFile.name : null,
        };

        // add user message
        setChatMessages((prev) => ({
            ...prev,
            [ticket.id]: [...(prev[ticket.id] || []), newMessage],
        }));

        setChatInput("");
        setAttachedFile(null);

        // ✅ Add support reply after 1 second
        setTimeout(() => {
            const replyMessage = {
                sender: "rep",
                text: "Thanks for reaching out! We are checking your issue.",
                time: formatTime(),
                file: null,
            };

            setChatMessages((prev) => ({
                ...prev,
                [ticket.id]: [...(prev[ticket.id] || []), replyMessage],
            }));
        }, 1000);
    };



    return (
        <ReusableModal open={open} onClose={onClose}>
            <Box sx={{ display: "flex", flexDirection: "column", height: "400px" }}>
                {/* Header */}
                <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ fontSize: "20px" }}>
                    Chat - Ticket #{ticket?.id}
                </Typography>

                {/* Chat Area */}
                <Box
                    sx={{
                        flex: 1,
                        border: "1px solid #ddd",
                        borderRadius: 2,
                        padding: 2,
                        overflowY: "auto",
                        mb: 2,
                    }}
                >
                    {!chatMessages[ticket?.id] || chatMessages[ticket?.id].length === 0 ? (
                        <Typography
    variant="body2"
    color="text.secondary"
    sx={{ fontSize: "16px" }} // 🔹 Increased font size only
  >
    No messages yet. Start the conversation!
  </Typography>
                    ) : (
                        chatMessages[ticket.id].map((msg, idx) => (
                            <Box
                                key={idx}
                                sx={{
                                    mb: 1.5,
                                    textAlign: msg.sender === "user" ? "right" : "left",
                                }}
                            >
                                {/* Chat Bubble */}
                                <Box
                                    sx={{
                                        display: "inline-block",
                                        padding: "6px 12px",
                                        borderRadius: 2,
                                        backgroundColor: msg.sender === "user" ? "#007bff" : "#f1f1f1",
                                        color: msg.sender === "user" ? "white" : "black",
                                        maxWidth: "70%",
                                        wordWrap: "break-word",
                                    }}
                                >
                                    {/* Text message */}
                                    {msg.text && (
                                        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                                            {msg.text}
                                        </Typography>
                                    )}

                                    {/* File attachment */}
                                    {msg.file && (
                                        <Typography 
                                            variant="body2"
                                            sx={{
                                                display: "block",
                                                color: msg.sender === "user" ? "#d1e9ff" : "blue",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                                mt: msg.text ? 0.5 : 0,
                                                fontSize: "20px",
                                            }}
                                            onClick={() => alert(`Download: ${msg.file}`)} // replace with download logic
                                        >
                                            📎 {msg.file}
                                        </Typography>
                                    )}
                                </Box>

                                {/* Timestamp */}
                                <Typography
                                    variant="caption"
                                    sx={{ display: "block", mt: 0.3, color: "gray" }}
                                >
                                    {msg.time}
                                </Typography>
                            </Box>
                        ))
                    )}
                </Box>


               
                {/* Input Section with Attach inside */}
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Type your message"
                        value={chatInput}
                        onChange={(e) => setChatInput(e.target.value)}
                        fullWidth
                       
                        InputProps={{
    sx: {
      "&::placeholder": {
        fontSize: "16px", // increases placeholder size
      },
      fontSize: "16px", // increases actual typed text size
    },
                            endAdornment: (
                                <>
                                    {/* Hidden File Input */}
                                    <input
                                        type="file"
                                        id="fileInput"
                                        style={{ display: "none" }}
                                        onChange={(e) => {
                                            if (e.target.files[0]) {
                                                setAttachedFile(e.target.files[0]);
                                            }
                                        }}
                                    />

                                    {/* Attach Button inside field */}
                                    <Button
                                        onClick={() => document.getElementById("fileInput").click()}
                                        sx={{ minWidth: "auto", ml: 1 , pr : 0}}
                                    >
                                        < MdOutlineAttachFile />
                                    </Button>
                                </>
                            ),
                        }}
                    />

                    {/* Send Button */}
                    <Button variant="contained" onClick={handleSend} sx={{
    fontSize: "16px" }}>
                        Send
                    </Button>
                </Box>

                {/* File Preview */}
                {attachedFile && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            border: "1px solid #ccc",
                            borderRadius: 2,
                            padding: "4px 8px",
                            backgroundColor: "#f9f9f9",
                            mt: 1,
                        }}
                    >
                        <Typography variant="body2">{attachedFile.name}</Typography>
                        <Button size="small" color="error" onClick={() => setAttachedFile(null)}>
                            ❌
                        </Button>
                    </Box>
                )}


            </Box>
        </ReusableModal>
    );
};

export default ChatModal;
